(function() {
  var ns = window.nspace("ccc.viz.map.config");

  ns.MapConfig = {
    /**
     * URL endpoint for our choropleth overlay service
     */
    serviceUrl: "/ChoroplethOverlayService.axd",

    dataUrl: "/api/MapData/GetMapData",

    alpha: "0.7", // Everywhere else says "opacity" instead of "alpha", so commenting just to find this more easily: MAP OPACITY HERE

    noDataColor: { color: "#FFFFFF" },

    themeColors: [
      {
        color: "#FFFFCC"
      },
      {
        color: "#A1DAB4"
      },
      {
        color: "#41B6C4"
      },
      {
        color: "#2C7FB8"
      },
      {
        color: "#253494",
        textColor: "#ececec"
      }
    ],

    /**
     * Returns a string specifying theme colors in the format required by the choropleth
     * overlay service in the form:
     * alpha|no data color|color1,color2,...,colorN
     */
    getThemeColorString: function() {
      return (
        this.alpha +
        "|" +
        this.noDataColor.color +
        "|" +
        _.map(this.themeColors, function(obj) {
          return obj.color;
        }).join(",")
      );
    },

    /**
     * The number of different "buckets" into which to sort the data values.
     */
    getNumBreaks: function() {
      // Calculate numBreaks from the number of themeColors
      return this.themeColors.length;
    },

    /**
     * Minimum map zoom
     */
    minZoom: 6,

    /**
     * Maximum map zoom
     */
    maxZoom: 18,

    /**
     * Mouseover Polygon style
     */
    mouseoverPolygonStyle: {
      strokeColor: "#333",
      strokeWeight: 2,
      fillOpacity: 0,
      zIndex: 10
    },

    /**
     * Selected Polygon style
     */
    selectedPolygonInnerStyle: {
      strokeColor: "#333",
      strokeWeight: 2,
      fillOpacity: 0,
      clickable: false,
      zIndex: 2
    },
    selectedPolygonOuterStyle: {
      strokeColor: "#fbd100",
      strokeWeight: 5,
      strokeOpacity: 0.8,
      fillOpacity: 0,
      clickable: false,
      zIndex: 1
    },

    /**
     * The location id for New York City stored statically.
     */
    nycLocationId: 1,

    /**
     * The fips for New York City stored statically.
     */
    nycFips: 3651000
  };
})();
